'use strict';

var markerIcon;

if (typeof google === 'undefined') {
	// This is likely because offline.
	// Above line uses typeof because we don't know if the variable was declared or not
	console.warn('google object not defined.');
} else {
	markerIcon = {
	default: {
		url: 'assets/images/design/map-marker.png',
		anchor: new google.maps.Point(20,57)
	}
	};
}


module.exports = {
    icon: markerIcon
};
